import { render, staticRenderFns } from "./ClientDocuments.vue?vue&type=template&id=7f71259d&scoped=true&"
import script from "./ClientDocuments.vue?vue&type=script&lang=js&"
export * from "./ClientDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocuments.vue?vue&type=style&index=0&id=7f71259d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f71259d",
  null
  
)

export default component.exports